class Wave extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <svg width="370" height="20" version="1.1" viewBox="0 0 370 20">
        <g transform="translate(0 -104.56)">
         <path className="path" d="m370 104.56h-370l-1.3772e-4 10s93.901 21.484 185 0.69051c91.099-20.794 185-0.69051 185-0.69051z"/>
        </g>
      </svg>
    )
  }
}

export default Wave
